import React from "react"
import { Icon } from "react-bulma-components"

const Socials: React.FC = () => {
  return (
    <footer className="socials">
      <a className="social-link-styling" href="https://github.com/Beatso">
        <Icon size="large">
          <i className="fab fa-2x fa-github"></i>
        </Icon>
      </a>

      <a className="social-link-styling" href="https://discord.gg/bNcZjFe">
        <Icon size="large">
          <i className="fab fa-2x fa-discord"></i>
        </Icon>
      </a>

      <a className="social-link-styling" href="https://twiiter.com/beatso_">
        <Icon size="large">
          <i className="fab fa-2x fa-twitter"></i>
        </Icon>
      </a>

      <a
        className="social-link-styling"
        href="https://www.youtube.com/channel/UC8xwWpzMuEbQ9X1MPm5zUUQ"
      >
        <Icon size="large">
          <i className="fab fa-2x fa-youtube"></i>
        </Icon>
      </a>

      <a className="social-link-styling" href="https://www.npmjs.com/~beatso">
        <Icon size="large">
          <i className="fab fa-2x fa-npm"></i>
        </Icon>
      </a>

      <a className="social-link-styling" href="http://instagram.com/beatso_mc">
        <Icon size="large">
          <i className="fab fa-2x fa-instagram"></i>
        </Icon>
      </a>

      <a className="social-link-styling" href="https://www.twitch.tv/beatso24">
        <Icon size="large">
          <i className="fab fa-2x fa-twitch"></i>
        </Icon>
      </a>
    </footer>
  )
}

export default Socials
